import { create } from 'zustand';

interface UseTopicGroupButtonOptionsStore {
  mode: 'topics' | 'keywords';
  setMode: (mode: 'topics' | 'keywords') => void;
}
/**
 *
 */
export const useTopicGroupButtonOptionsStore = create<UseTopicGroupButtonOptionsStore>((set) => ({
  mode: 'topics',
  setMode: (mode: 'topics' | 'keywords') => set({ mode })
}));
